var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoffee(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 45,
    fill: "none",
    viewBox: "0 0 37 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#262323",
    d: "M6.537 12.349c.874 0 1.582-.708 1.582-1.582V1.582a1.581 1.581 0 1 0-3.164 0v9.185c0 .874.707 1.582 1.582 1.582Zm26.938 6.328h-5.273a3.162 3.162 0 0 0-3.164-3.164H3.24a3.162 3.162 0 0 0-3.164 3.164v10.898c0 .15.009.295.03.435-.021.308-.03.615-.03.927C.077 38.703 6.374 45 14.14 45c7.035 0 12.862-5.164 13.9-11.91h5.435a3.162 3.162 0 0 0 3.164-3.163V21.84a3.162 3.162 0 0 0-3.164-3.164Zm-8.437 11.25h-.048c.03.334.048.668.048 1.01 0 6.021-4.878 10.899-10.899 10.899-6.02 0-10.898-4.878-10.898-10.898 0-.343.018-.677.048-1.011h-.048v-11.25h21.797v11.25Zm8.437-.352h-4.922v-7.734h4.922v7.734ZM21.39 12.35c.875 0 1.582-.708 1.582-1.582V1.582a1.581 1.581 0 1 0-3.164 0v9.185c0 .874.708 1.582 1.582 1.582Zm-7.47 0c.874 0 1.582-.708 1.582-1.582V1.582a1.581 1.581 0 1 0-3.164 0v9.185c0 .874.707 1.582 1.582 1.582Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffee);
export default __webpack_public_path__ + "static/media/Coffee.11380004cdfc54b2ff611b5a79b30f99.svg";
export { ForwardRef as ReactComponent };